export default __webpack_public_path__ + "static/media/viewtoside1.a1705181.jpg";